import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPencil = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.5 20.8333H21.875",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17.1875 3.6458C17.6019 3.2314 18.1639 2.9986 18.75 2.9986C19.0402 2.9986 19.3275 3.05575 19.5956 3.1668C19.8637 3.27785 20.1073 3.44061 20.3125 3.6458C20.5177 3.851 20.6805 4.09459 20.7915 4.36269C20.9026 4.63078 20.9597 4.91812 20.9597 5.2083C20.9597 5.49849 20.9026 5.78583 20.7915 6.05392C20.6805 6.32202 20.5177 6.56561 20.3125 6.7708L7.29167 19.7916L3.125 20.8333L4.16667 16.6666L17.1875 3.6458Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgPencil;
